<template>
  <b-container>
    <b-row>
      <b-col>
        <div class="brand-logo-container">
          <figure class="brand-logo">
            <a
              href="https://www.matchesfashion.com"
              alt="Matches Fashion"
              target="_blank"
              rel="noopener noreferrer"
              class="brand-link"
            >
              <img
                class="brand-image"
                src="~@/assets/img/logos/matches_fashion_logo_2.png"
              />
            </a>
          </figure>

          <figure class="brand-logo">
            <a
              href="https://www.mrporter.com"
              alt="Mr Porter"
              target="_blank"
              rel="noopener noreferrer"
              class="brand-link"
            >
              <img
                class="brand-image"
                src="~@/assets/img/logos/mr_porter_logo_2.png"
              />
            </a>
          </figure>

          <figure class="brand-logo last">
            <a
              href="https://www.endclothing.com"
              alt="End Clothing"
              target="_blank"
              rel="noopener noreferrer"
              class="brand-link"
            >
              <img
                class="brand-image"
                src="~@/assets/img/logos/end_clothing_logo_2.png"
              />
            </a>
          </figure>

          <figure class="brand-logo last">
            <a
              href="https://www.uniqlo.com"
              alt="Uniqlo"
              target="_blank"
              rel="noopener noreferrer"
              class="brand-link"
            >
              <img
                class="brand-image"
                src="~@/assets/img/logos/uniqlo_logo.svg"
              />
            </a>
          </figure>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.brand-logo-container {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;

  .brand-logo {
    max-width: calc(33.333333333% - 20px);
    margin: 0 10px;

    .brand-link,
    .brand-image {
      max-width: 100%;
      max-height: 30px;
    }
    .brand-image {
      opacity: 0.4;

      &:hover {
        opacity: 1;
      }
    }

    &.last {
      margin: 0 0 0 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/brandsDisplay/index.vue